import React from 'react'
import { FormattedMessage } from 'react-intl'
import Modal from 'components/util/Modal'
import styles from './_refreshingModal.css'
import Loader from 'components/util/Loader'

function RefreshingModal (props) {
  return (
    <Modal
      {...props}
      effect='smooth'
      shouldCloseOnMaskClick={false}
      shouldCloseOnEscKey={false}
    >
      <div className={styles.container}>
        <div>
          <Loader height={50} width={50} />
        </div>
        <h3 className={styles.message}>
          <FormattedMessage
            id='layout.refreshing_modal.message'
            defaultMessage='Refreshing auth token'
          />
        </h3>
      </div>
    </Modal>
  )
}

export default RefreshingModal



// WEBPACK FOOTER //
// ./src/components/auth/RefreshingModal.jsx